import { InnerQueryExpression } from "../InnerQueryExpression";

export type BinaryOperationType = "Equals" | "Less" | "LessOrEquals" | "Greater" | "GreaterOrEquals";

export class CompareExpression implements InnerQueryExpression {
    public readonly $discriminator = "Compare";
    public readonly left: InnerQueryExpression;
    public readonly operationType: BinaryOperationType;
    public readonly right: InnerQueryExpression;

    public constructor(left: InnerQueryExpression, operationType: BinaryOperationType, right: InnerQueryExpression) {
        this.left = left;
        this.operationType = operationType;
        this.right = right;
    }
}
